import { Suspense, lazy } from "react";
import DashboardLayout from "../layouts/dashboard";
import { PATH_AUTOMATION_BUILD, PATH_AUTOMATIONS } from "./paths";
import { Outlet } from "react-router-dom";
import AuthGuard from "../guards/AuthGuard";
import Loader from "@/components/Loader";
import { IS_PRODUCTION } from "@/config";

const AutomationsWorkflowsContainer = lazy(() => import("@pages/automations/automations.container"));
const AutomationsDetailContainer = lazy(() => import("@pages/automations/detail/workflow-detail-container"));
const WorkflowBuilderContainer = lazy(() => import("@pages/automations/builder/workflow-builder-container"));

/**
 * Not registered in production builds (module not ready for customers), so
 * `/automations` and the builder fall through to the global 404;
 * routes.config.ts hides the sidebar entry. Local/staging keep them.
 */
const automationRoutes = IS_PRODUCTION ? [] : [
  {
    path: PATH_AUTOMATIONS,
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<Loader />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <AutomationsWorkflowsContainer />, index: true },
      { path: ":workflowId", element: <AutomationsDetailContainer /> },
    ],
  },
  // Full screen, no dashboard chrome — same pattern as the Email Template
  // editor route in settings.routes.tsx.
  {
    path: PATH_AUTOMATION_BUILD,
    element: (
      <AuthGuard>
        <Suspense fallback={<Loader />}>
          <WorkflowBuilderContainer />
        </Suspense>
      </AuthGuard>
    ),
  },
];

export default automationRoutes;
